// Product card "+N more colors": expand in place. First click fetches the remaining swatches (this product + sub-products); later clicks just show/hide.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-more-colors]');
  if (!btn) return;
  e.preventDefault();
  var list = btn.closest('.color-swatch-list');
  var expanded = list.classList.toggle('is-expanded');
  if (!expanded) { btn.textContent = btn.dataset.label; return; }
  btn.textContent = btn.dataset.less;

  var handles = (btn.dataset.handles || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean);
  if (!handles.length || btn.dataset.loaded) return;
  btn.dataset.loaded = '1';
  var name = btn.dataset.name;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  btn.classList.add('is-loading');
  Promise.all(handles.map(function (h) {
    return fetch(root + 'products/' + h + '?section_id=card-more-swatches')
      .then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
  })).then(function (htmls) {
    var have = {}, i = 0, tmp = document.createElement('div');
    list.querySelectorAll('.color-swatch').forEach(function (s) { have[s.dataset.color] = 1; });
    tmp.innerHTML = htmls.join('');
    tmp.querySelectorAll('.color-swatch').forEach(function (s) {
      if (have[s.dataset.color]) return;
      have[s.dataset.color] = 1;
      var inp = s.querySelector('input'), lab = s.querySelector('label'), id = name + '-x' + (i++);
      inp.name = name; inp.id = id; inp.checked = false; lab.htmlFor = id;
      s.classList.add('color-swatch--extra');
      list.insertBefore(s, btn);
    });
    btn.classList.remove('is-loading');
  });
});